import React from 'react';
import Icon from './Icon';
import { fonts } from '../theme';

export default function TopBar({ t, dark = false, title, onMenu, transparent = false }) {
  const ink = dark ? t.paper : t.ink;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '8px 18px 12px',
      background: transparent ? 'transparent' : 'transparent',
      color: ink,
      position: 'relative', zIndex: 10,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 28, height: 28, borderRadius: 999,
          background: ink, color: dark ? t.ink : t.paper,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: fonts.serif, fontSize: 14, fontWeight: 500, fontStyle: 'italic',
        }}>m</div>
        {title && <div style={{ fontFamily: fonts.sans, fontSize: 13, fontWeight: 500 }}>{title}</div>}
      </div>
      <button onClick={onMenu} style={{
        appearance: 'none', border: 'none', background: 'transparent', cursor: 'pointer',
        color: ink, padding: 6, display: 'flex', alignItems: 'center', gap: 4,
        fontFamily: fonts.mono, fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase',
      }}>
        <span>Menu</span>
        <Icon name="menu" size={18} sw={1.5} />
      </button>
    </div>
  );
}
